var path = '/templates/projects.campaigns/views/directives/campaign_coupon_applicable_rate.html';
var html = "<div ng-show=\"Devise.isMaster() && coupon_applicable_rate != null\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignCouponApplicableRate.label' | translate: { campaign_coupon_applicable_rate: (coupon_applicable_rate * 100 || 0 | number:2) } }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_coupon_applicable_rate.html
// module id = 1360
// module chunks = 0